<template>
  <div>
    <vs-tooltip v-if="hasTooltip" class="flex" :position="tooltipPosition">
      <template #content>
        <slot name="tooltip" />
      </template>

      <img :src="iconPath" class="h-4 w-4" />
    </vs-tooltip>

    <span v-else>
      <img :src="iconPath" class="h-4 w-4" />
    </span>
  </div>
</template>

<script>
import fullyAutomatedIcon from '@/assets/images/icons/outcome_fully_automated.svg'
import partiallyAutomatedIcon from '@/assets/images/icons/outcome_partially_automated.svg'
import wrongAnswerIcon from '@/assets/images/icons/outcome_wrong_answer.svg'
import notAutomatedIcon from '@/assets/images/icons/outcome_not_automated.svg'
import requestedOperatorIcon from '@/assets/images/icons/outcome_requested_operator.svg'
import conversationTimeoutIcon from '@/assets/images/icons/conversation_timeout.svg'
import servedByBotIcon from '@/assets/images/icons/served_by_bot.svg'
import servedByOperatorIcon from '@/assets/images/icons/served_by_operator.svg'
import operatorNotReachableIcon from '@/assets/images/icons/operator_not_reachable.svg'

const ICON_MAP = {
  fullyAutomated: fullyAutomatedIcon,
  partiallyAutomated: partiallyAutomatedIcon,
  wrongAnswer: wrongAnswerIcon,
  notAutomated: notAutomatedIcon,
  requestedOperator: requestedOperatorIcon,
  servedByBot: servedByBotIcon,
  servedByOperator: servedByOperatorIcon,
  agentOffline: operatorNotReachableIcon,
  conversationTimeout: conversationTimeoutIcon,
  positiveFeedback: fullyAutomatedIcon,
  negativeFeedback: wrongAnswerIcon,
  notRated: notAutomatedIcon
}

export default {
  name: 'ChartLegendIcon',
  props: {
    type: {
      type: String,
      required: true
    },
    hasTooltip: {
      type: Boolean,
      required: true
    },
    tooltipPosition: {
      type: String,
      default: 'top'
    }
  },

  computed: {
    iconPath() {
      return ICON_MAP[this.type] || ''
    }
  }
}
</script>
